import { DateTime } from 'luxon';
import toLuxonObject from './toLuxonObject';

export default function toISOMonthString(date, currentFormat) {
  const dateObj = (date instanceof DateTime) ? date : toLuxonObject(date, currentFormat);
  if (!dateObj) return null;

  // Ensure consistent performance by using string concatenation
  // instead of template literals in a hot path.
  // eslint-disable-next-line prefer-template
  return dateObj.year + '-' + String(dateObj.month).padStart(2, '0');
}
